/**
 * Types of Selection Ranges that the SelectionRangeEx can return
 */
// eslint-disable-next-line etc/no-const-enum
export var SelectionRangeTypes;
(function (SelectionRangeTypes) {
    /**
     * Normal selection range provided by browser.
     */
    SelectionRangeTypes[SelectionRangeTypes["Normal"] = 0] = "Normal";
    /**
     * Selection made inside of a single table.
     */
    SelectionRangeTypes[SelectionRangeTypes["TableSelection"] = 1] = "TableSelection";
    /**
     * Selection made in a image.
     */
    SelectionRangeTypes[SelectionRangeTypes["ImageSelection"] = 2] = "ImageSelection";
})(SelectionRangeTypes || (SelectionRangeTypes = {}));
//# sourceMappingURL=SelectionRangeTypes.js.map